export default {
    timerDuration: 15,
    tryDuration1: 1500,
    tryDuration2: 2500,
    tryDuration3: 4500,
    startRound: 0,
    endRound: 5,
    wrongAnswerTimeout: 5000,
    rightAnswerTimeout: 5000,
    trackDuration: -1,
    startScore1: 0,
    startScore2: 0,
    startIntroStep: 0,
    startTry: 0,
};
